<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-user-alt"></i>
        Group(Customer) SignUp
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">management</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Group</a>
        </li>
      </ul>
    </div>
    <b-card>
      <div class="d-flex flex-wrap align-items-center">
        <div class="title mr-auto">
          SignUp
        </div>
        <span class="float-right">{{model.last_addr || '-'}}@{{model.created_at | sdate}}</span>
      </div>
      <hr>
      <div class="row mb-2">
        <div class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" label-for="ph_use" v-b-tooltip.hover>
            Allow login
          </label>
        </div>
        <div class="col-xl-4 col-md-12  d-flex align-self-center">
          <div class="checkbox-switch">
            <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="model.is_alive" :disabled="lock">
            <div class="checkbox-animate disabled">
              <span class="checkbox-off">OFF</span>
              <span class="checkbox-on">ON</span>
            </div>
          </div>
        </div>
        <div class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_permisson">
            Permission
          </label>
        </div>
        <div class="col-xl-4 col-md-12 d-flex align-self-center">
          <v-select v-if="!lock" label="permisson" v-model="model.level" :options="level_list"></v-select>
          <b-form-input type="text" v-if="lock" :value="model.level" plaintext></b-form-input>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_permisson">Service</label>
        </div>
        <div class="col-xl-4 col-md-12 align-self-center">
          <b-badge :variant="model.service == 'Basic' ? 'info' : 'success'">{{model.service ? model.service : '-'}}</b-badge>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_company">Company</label>
        </div>
        <div class="col-xl-4 col-md-12  d-flex align-self-center">
          <b-form-input type="text" id="ph_company" v-model="model.company" :plaintext="lock"></b-form-input>
        </div>
        <div class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_nickname">Name</label>
        </div>
        <div class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-input type="text" id="ph_nickname" v-model="model.nickname" :plaintext="lock"></b-form-input>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_address">Address</label>
        </div>
        <div class="col-xl-4 col-md-12  d-flex align-self-center">
          <b-form-input type="text" id="ph_address" v-model="model.address" :plaintext="lock"></b-form-input>
        </div>
        <div class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_username">E-mail(ID)</label>
        </div>
        <div class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-input type="text" id="ph_username" v-model="model.username" :plaintext="lock"></b-form-input>
        </div>
      </div>
      <div class="d-flex flex-wrap align-items-center mt-5">
        <div class="title mr-auto">
          Region
        </div>
      </div>
      <hr>
      <b-row class="mb-2">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_timezone">Timezone(*)</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <v-select :readonly="true" :disabled="lock" label="name" v-model="region.timezone" :options="codes.timezone" ></v-select>
        </b-col>
      </b-row>
      <b-button size="sm" variant="success" @click="partner_connect_modal = true"> Accept </b-button>
      <b-button size="sm" variant="danger" @click="confirm = true"> Reject </b-button>
      <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
    </b-card>
    <b-modal title="User Remove"  class="modal-danger" v-model="confirm" @ok="reject" ok-variant="danger">
      <!-- Are you sure you do not approve the subscriber and want to delete ? -->
      <div class="form-group">
        <label for="reason">Please enter a reason why you did not approve.</label>
        <textarea class="form-control" id="reason" rows="3" v-model="model.reason"></textarea>
        <hr>
        <b-checkbox v-model="model.is_mail">sending you the reason by mail({{model.username}})</b-checkbox>
      </div>
    </b-modal>

    <!-- 파트너 연결 모달 -->
    <b-modal size='xl' title="Connect Partner"  class="modal-primary" v-model="partner_connect_modal" ok-only ok-variant="danger">
      <partner-List :enable_new="false" @select="select_partner" :view_detail="false"></partner-List>
    </b-modal>
    <!-- 파트너 연결 모달 -->
    <b-modal size='ml' title="Sign to partner"  class="modal-primary" v-model="confirm_modal" ok-variant="danger" @ok="accept">
      Would you like to register as your partner?
      <hr>
      Parter : {{model.partner ? model.partner.username : '-'}}
      <hr>
      Group(Customer) : {{model.username}}
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>